module.exports = __webpack_public_path__ + "static/img/map.b49223b9.png";